import { getMfeLogPayload } from '@src/utils/getMfeLogPayload';
import { nanoid } from 'nanoid';

declare global {
  interface Window {
    ShadyCSS?: {
      getComputedStyleValue: (element: HTMLElement, proeprty: string) => unknown
    };
  }
}

export const getComputedStyleValue = (element: HTMLElement, property: string) => (window.ShadyCSS
  ? window.ShadyCSS.getComputedStyleValue(element, property)
  : window.getComputedStyle(element).getPropertyValue(property));

export const makeCopy = <T>(from: T) => JSON.parse(JSON.stringify(from)) as T;

export const assert = (value: unknown, message: string, initData: Record<string, string> = {}) => {
  if (!value) {
    if (window.localStorage.getItem('tef-coms-debug-mode')) {
      const payload = getMfeLogPayload('tef-coms', initData);
      window.console.info('[tef-coms] assert log', payload); // eslint-disable-line 
    }
    throw new Error(message);
  }
};

export const getTracingHeaders = (traceid = nanoid()) => {
  const requesttraceid = nanoid();
  return {
    'tef-coms-clienttraceid': traceid,
    'tef-coms-traceid': requesttraceid,
    activityid: `${traceid}|${requesttraceid}`, // for api gateway, ignored by COMS
  };
};

export const encodeHtmlEntities = (rawStr: string) => rawStr.replace(
  /[\u00A0-\u9999<>&"]/gim,
  (i) => `&#${i.charCodeAt(0)};`,
);
